<script setup lang="ts">
/** EDD 헤더 — 적용 요건 / 상황 안내 (정적). */
</script>

<template>
  <div>
    <div class="cdd-title">Enhanced Customer Due Diligence <span class="cdd-cn">加强客户尽职调查</span> (EDD)</div>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-sec">Enhanced Customer Due Diligence (EDD)</td></tr>
        <tr><td class="cdd-intro">
          <div>EDD as required under: <span class="cdd-cn">根据以下要求进行加强客户尽职调查（EDD）</span></div>
          <div class="bullet">•&nbsp; Section 16 of the AMLA; and</div>
          <div class="cdd-cn">《反洗钱、反恐融资及非法活动收益法》（AMLA）第16条；以及</div>
          <div class="bullet">•&nbsp; Paragraph 14 of the AML/CFT/CPF and TFS for DNFBPs and NBFIs policy document.</div>
          <div class="cdd-cn">反洗钱、反恐融资、反扩散融资及针对DNFBPs和NBFIs的定向金融制裁政策文件第14段。</div>
          <div style="margin-top:6px;font-weight:700">Circumstances when EDD applies: <span class="cdd-cn">适用加强客户尽职调查（EDD）的情况：</span></div>
          <div class="bullet">•&nbsp; Dealing with foreign PEPs</div>
          <div class="cdd-cn">与外国政治公众人物（Foreign PEPs）交易</div>
          <div class="bullet">•&nbsp; Dealing with person from higher risk countries</div>
          <div class="cdd-cn">与来自较高风险国家的人士交易</div>
          <div class="bullet">•&nbsp; For gatekeepers (lawyers, accountants, company secretaries and trust companies), where nominee services are provided</div>
          <div class="cdd-cn">对于守门人（律师、会计师、公司秘书及信托公司），在提供代名人服务时</div>
          <div class="bullet">•&nbsp; Dealing with domestic PEPs or customers assessed as having higher ML/TF/PF risks based on customer risk profiling</div>
          <div class="cdd-cn">与国内政治公众人物或经客户风险分析评估为具有较高洗钱/恐融/扩融风险的客户交易</div>
          <div style="margin-top:6px"><b>Note</b><span class="cdd-cn">注</span>: For enhanced on-going due diligence, higher frequency of transaction monitoring is required to enable reporting institutions to identify any anomalies.</div>
          <div class="cdd-cn">对于加强持续尽职调查，需要更高频率的交易监控，以使申报机构能够识别任何异常。</div>
        </td></tr>
      </tbody>
    </table>
  </div>
</template>
